import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import { Dialog } from '@material-ui/core';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import DialogTitle from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/DialogTitle';
import DialogContent from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/DialogContent';
import AccomplishmentsTab
  from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Accomplishments/AccomplishmentsTab';
import DialogActions from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/DialogActions';
import Button from 'Components/Ant/Button';

const styles = () => ({
  root: {},
  content: {
    display: 'block',
  },
});

const AccomplishmentsModal = ({
  classes,
  className,
  onClose,
}) => {
  const { rootNodeProps } = useEventTrackingLogEvent({
    nodeName: 'Client Accomplishments',
    isPageView: true,
  });

  return (
    <Dialog
      {...rootNodeProps}
      open
      maxWidth="lg"
      scroll="body"
      className={classNames(className, classes.root)}
    >
      <DialogTitle>Client Accomplishments</DialogTitle>
      <DialogContent classes={classes.content}>
        <AccomplishmentsTab />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

AccomplishmentsModal.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
};

AccomplishmentsModal.defaultProps = {
  className: '',
};

export default withStyles(styles)(AccomplishmentsModal);
